import React from 'react'

interface SectionTitleProps {
  title: string
  subtitle?: string
  centered?: boolean
  className?: string
}

const SectionTitle: React.FC<SectionTitleProps> = ({ title, subtitle, centered = true, className }) => {
  return (
    <div className={`${centered ? 'text-center' : ''} mb-6 sm:mb-12 ${className || ''}`}>
      <h2 className="text-2xl sm:text-3xl lg:text-4xl font-extrabold font-heading text-foreground">
        {title}
      </h2>
      {subtitle && (
        <p className="mt-2 sm:mt-3 text-base sm:text-lg text-foreground-muted">
          {subtitle}
        </p>
      )}
    </div>
  )
}

export default SectionTitle
